import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

import { Lookup } from '@shared/interfaces/lookup';

@Injectable({
    providedIn: 'root'
})
export class LookupUseCacheService {
    private http = inject(HttpClient);

    private _useCache : boolean = false;
    private cache = new Map<string, Observable<Array<Lookup>>>();

    set isUsingCache(value: boolean) {
        this._useCache = value;

        if (!value) {
            this.cache.clear();
        }
    }

    getOptions(url: string): Observable<Array<Lookup>> {
        if (!this._useCache) {
            return this.http.get<Array<Lookup>>(url);
        }

        if (!this.cache.has(url)) {
            const request$ = this.http.get<Array<Lookup>>(url).pipe(
                shareReplay(1) // cache the response
            );
            this.cache.set(url, request$);
        }

        return this.cache.get(url)!;
    }
}
